// Tiny 0-100% confidence bar with numeric label. Pure inline component.

export default function ConfidenceBar({ value = 0, testid }) {
  const pct = Math.round(Math.max(0, Math.min(1, value)) * 100);
  const tone =
    pct >= 80 ? "bg-emerald-500" :
    pct >= 50 ? "bg-amber-500" :
                "bg-slate-400";
  return (
    <div className="flex items-center gap-2" data-testid={testid}>
      <div className="h-1.5 w-24 rounded-full bg-slate-100 overflow-hidden">
        <div className={`h-full ${tone}`} style={{ width: `${pct}%` }} />
      </div>
      <span className="text-[11px] font-mono text-[#4B5773]">{pct}%</span>
    </div>
  );
}
